// extracted by mini-css-extract-plugin
export default {"applicantName":"FormEmployeeNameAndBirth_applicantName__JA1SR"};